import { UPDATE_ITEMS } from "../actions/types";

const initialState = {
    updated: 0,
};

const updateReducer = (state = initialState, action) => {
    switch(action.type){
        case UPDATE_ITEMS:
            return{
                ...state,
                updated: state.updated + 1,
            };

            default:
                return state;
    }
};

export default updateReducer;